/* eslint eqeqeq: 0 */

import React, { Component } from "react";
import { Row, Col } from "reactstrap";
import { CRUDFunction } from "reduxCURD/container";
import BackupsList from "./BackupsList";
import _ from "lodash";
import { getServerEndpoint } from "../../../utils/serverEndpoint";
import { sanitizedFilename } from "../../../utils/utils";

class Backups extends Component {
  constructor(props) {
    super(props);
    this.state = {
      backupsList: [],
    };

    this.handleDeleteClick = this.handleDeleteClick.bind(this);
    this.handleDownloadClick = this.handleDownloadClick.bind(this);
  }

  componentDidMount() {
    this.props.getBackups();
  }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   if (
  //     nextProps.applicationlookupss &&
  //     nextProps.applicationlookupss !== prevState.categories &&
  //     nextProps.actionType !== prevState.actionType &&
  //     nextProps.actionType == "BACKUPSS_READ_SUCCESS"
  //   ) {
  //     return {
  //       categories: nextProps.applicationlookupss,
  //       actionType: nextProps.actionType,
  //     };
  //   } else if (nextProps.actionType !== prevState.actionType && nextProps.actionType == "APPLICATIONLOOKUPS_UPDATE_SUCCESS") {
  //     return {
  //       actionType: nextProps.actionType,
  //     };
  //   } else if (nextProps.actionType !== prevState.actionType && nextProps.actionType == "APPLICATIONLOOKUPS_CREATE_SUCCESS") {
  //     return {
  //       actionType: nextProps.actionType,
  //     };
  //   } else if (nextProps.actionType !== prevState.actionType && nextProps.actionType == "APPLICATIONLOOKUPS_DELETE_SUCCESS") {
  //     return {
  //       actionType: nextProps.actionType,
  //     };
  //   } else if (nextProps.actionType !== prevState.actionType && nextProps.actionType == "APPLICATIONLOOKUPS_DELETE_FAILURE") {
  //     return {
  //       actionType: nextProps.actionType,
  //     };
  //   } else {
  //     return null;
  //   }
  // }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.actionType !== this.props.actionType &&
      this.props.actionType == "BACKUPSS_READ_SUCCESS" &&
      Array.isArray(this.props.backupss)
    ) {
      this.setState({
        backupsList: this.props.backupss,
      });
    }
    // if (prevState.actionType !== this.state.actionType && this.state.actionType == "APPLICATIONLOOKUPS_UPDATE_SUCCESS") {
    //   this.props.getApplicationlookups();
    // }
    // if (prevState.actionType !== this.state.actionType && this.state.actionType == "APPLICATIONLOOKUPS_CREATE_SUCCESS") {
    //   this.props.getApplicationlookups();
    // }
    // if (prevState.actionType !== this.state.actionType && this.state.actionType == "APPLICATIONLOOKUPS_DELETE_SUCCESS") {
    //   this.props.getApplicationlookups();
    // }
  }

  handleDeleteClick(id) {
    this.props.deleteBackups(id);
  }

  handleDownloadClick(name) {
    window.open(getServerEndpoint() + "dataBackups/" + sanitizedFilename(name));
  }

  // handleChange(category) {
  //   //console.log(category)
  //   let selectedCategoryData = [];
  //   this.state.categories.forEach((categoryObj) => {
  //     if (category == categoryObj.listName) {
  //       selectedCategoryData.push(categoryObj);
  //     }
  //   });
  //   this.setState({
  //     selectedCategory: category,
  //     selectedCategoryDetails: selectedCategoryData,
  //   });
  // }

  render() {
    const { backupsList } = this.state;
    return (
      <Col md="12">
        <Row style={{ borderBottom: "2px solid #d1d1d1", margin: "0px 15px", padding: "10px 0px" }}>
          <Col md="6" style={{ paddingLeft: "0px" }}>
            <div
              style={{
                float: "left",
                fontFamily: "Myriad Pro",
                fontSize: "24px",
                letterSpacing: "0.5px",
                color: "var(--first)",
              }}
            >
              Backups
            </div>
          </Col>
        </Row>
        {/* <Row>
          <Col md="12">
            <div style={commonPageStyle.commonSummaryHeadingContainer}>
              <h4 style={commonPageStyle.commonSummaryHeadingStyle}>Create Backup</h4>
            </div>
          </Col>
        </Row>

        <Col md="12">
          <Row style={{ height: "80px", margin: "0px" }}>
            <div style={{ marginRight: "30px" }}>
              <LocalForm
                className="commonform"
                model="selectedCategory"
                style={{ width: "250px" }}
                validators={this.trackValidator}
                onChange={(values) => this.handleChange(values)}
                initialState={this.state.selectedCategory}
              >
                <Field>
                  <Control.select model="selectedCategory" placeholder="Categories">
                    {categoriesOptions}
                  </Control.select>
                </Field>
              </LocalForm>
            </div>

            <div>
              <ButtonCirclePlus
                iconSize={70}
                icon={withPlus}
                handleClick={(e) => {
                  this.handleAddEditModalClick("Add");
                }}
                backgroundColor="#e3e9ef"
                margin="0px 0px 0px 0px"
                borderRadius="50%"
                hoverBackgroundColor="#e3e2ef"
                hoverBorder="0px"
                activeBorder="3px solid #e3e2ef "
                iconStyle={{
                  color: "#c4d4e4",
                  background: "var(--fifth)",
                  borderRadius: "50%",
                  border: "3px solid ",
                }}
              />
            </div>
          </Row>
        </Col> */}

        <Row>
          <Col md="12">
            <BackupsList
              tableData={backupsList}
              handleDeleteClick={this.handleDeleteClick}
              handleDownloadClick={this.handleDownloadClick}
            />
          </Col>
        </Row>
      </Col>
    );
  }
}

const DataBackupsContainer = CRUDFunction(Backups, "backups");

export default DataBackupsContainer;



// WEBPACK FOOTER //
// ./src/components/diagnostics/DataBackupsContainer/index.jsx